import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "@/AppRoutes";
import { captureAttribution } from "@/lib/attribution";
import { installClickTracking } from "@/lib/analytics";

// Pageviews are NOT fired from here. GA4 (G-6N6T7ZD55V) is loaded by the Google
// Tag Manager container in public/index.html: its Google tag sends the initial
// page_view and GA4 Enhanced Measurement ("page changes based on browser history
// events") covers client-side route changes. Firing page_view manually as well
// would double-count. Custom events go through src/lib/analytics.js.
//
// Per-page head tags (<title>, description, canonical, og/twitter) are plain
// React 19 elements rendered by components/site/SEO.jsx; React hoists them into
// document.head itself, so no head-manager provider is needed here.
function App() {
  // Feature 05 — remember first-touch referrer + UTM for this tab so a booking made
  // after a few client-side navigations still records where the visitor came from.
  useEffect(() => { captureAttribution(); }, []);
  // SEO audit batch 3, Part 5 — one document-level listener pushes phone_click /
  // text_click / email_click / cta_estimate_click (with `location`) exactly once per tap.
  useEffect(() => installClickTracking(), []);
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
